export default function stripHtml(html) {
  return $('<div>').html(html).text();
}
